// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"177":"home","701":"homeM"}[chunkId] + "." + {"177":"50df2583","701":"7f64ec54"}[chunkId] + ".css";
};